import React from 'react';

// Only <em> markers are interpreted. All other citation content is rendered
// as React text, so citation markup cannot inject arbitrary HTML.
export default function FormattedCitation({ value }) {
  const parts = String(value || '').split(/<em>([\s\S]*?)<\/em>/g);

  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? <em key={index}>{part}</em> : part
      )}
    </>
  );
}
